import { render, staticRenderFns } from "./GradientWrapper.vue?vue&type=template&id=fe0be6c6&scoped=true&"
import script from "./GradientWrapper.vue?vue&type=script&lang=js&"
export * from "./GradientWrapper.vue?vue&type=script&lang=js&"
import style0 from "./GradientWrapper.vue?vue&type=style&index=0&id=fe0be6c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0be6c6",
  null
  
)

export default component.exports